import i18n from "config/i18next";

i18n.addResources("es", "rainInputs", {
  datePlaceholder: "Seleccioná el día del bonus",
  dateLabel: "Fecha",
  rainTimeStartLabel: "Comienzo",
  rainTimeEndLabel: "Fin",
  rainTimeStartPlaceholder: "Ingresá el horario de comienzo",
  rainTimeEndPlaceholder: "Ingresá el horario de finalización",
});
